<!--  -->
<template>
  <div class="scan">
    <div class="header">
      <div class="ht">
        <img class="span-logo" src="../assets/imgs/LOGO_STEFANO_RICCI.svg" alt />
        <img class="exit" src="../assets/imgs/exit.png" alt @click="exit" />
        <!-- <div class="exit">
          <img class="logo" src="../assets/imgs/sr-logo.png" alt />
        </div>-->
      </div>
      <div class="user-msg">
        <img class="avatar" :src="clerkMsg.img" alt />
        <div class="shop-msg">
          <p class="shop-name">店铺: {{clerkMsg.shopName}}</p>
          <p class="staff-name">店员:{{clerkMsg.username}}</p>
        </div>
      </div>
    </div>

    <div class="scan-logo">
      <div class="nav-btn" @click="scan">
        <img src="../assets/imgs/saoma-gold.png" alt />
      </div>
    </div>

    <div class="record">
      <span @click="goRecord">核销记录</span>
    </div>
  </div>
</template>

<script>
import api from "../assets/js/api.js";
import util from "../assets/js/util.js";
import wx from "weixin-js-sdk";
import wxApi from "../assets/js/wxapi";
var that;
export default {
  data() {
    return {
      clerkMsg: {}
    };
  },

  components: {},

  computed: {},
  created() {
    that = this;
    that.clerkMsg = JSON.parse(util.getss("clerkMsg"));
  },

  mounted() {},

  methods: {
    scan() {
      if (wxApi.ready) {
        wx.scanQRCode({
          desc: "scanQRCode desc",
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: function(res) {
            that.$router.push({
              name: "ScanResult",
              params: { qrcode: res.resultStr }
            });
          },
          error: function(res) {
            if (res.errMsg.indexOf("function_not_exist") > 0) {
              alert("版本过低请升级");
            }
          }
        });
      } else {
        that.$toast({ message: "请稍候", duration: 2000 });
      }

      //  const qrcode = "GYZ732O262KPCQHQN3QBRGONJMR3FQLOBIOEIGR4LE7QJH2QX2SD5F3ZMXZO6KNHIWLOXSNAAFGMA3V6OMZ5SYJ6QBHTLSJQ7UYQJXOEJMAJ4KS7EDMNING3SZLNAKXY4KCG3SYXX4OV3OSHYHNSLGVIVIOIUG6KQYF4C5E55YZEXC3DPKLPLFSGDX2FIA363OTIYVKUYYNCBQLUF4HN2YEVWI3QF5H44WPIYQ6OWMBBASZIRPTWKALB7CE2OR7YLUZVQQZFFFSK2RLHMZYD5JMLH36IWXYS26UR5SPYURFNGJ35QGID3MVBXCGVKB6VJ5GRC5WRHVMNUPCBYIQ2KAJGS5KV6SXZPYRJEBUN6XUZM4ZVUBQ6YM4FWEBZBP6N"
      // that.$router.push({name: 'ScanResult', params: {qrcode}});
    },
    goRecord() {
      that.$router.push("./record");
    },
    exit() {
      that.$messagebox
        .confirm("确定要退出登录吗?")
        .then(action => {
          that.$http
            .get(api.dropOut, {
              params: {
                token: util.getss("token")
              }
            })
            .then(res => {
              if (res.code === util.ERR_OK) {
                that.$router.replace({ path: "./login" });
              } else {
                that.$toast({ message: res.msg, duration: 2000 });
              }
            });
        })
        .catch(err => {
          console.log();
        });
    }
  }
};
</script>
<style lang='stylus' scoped>
.scan {
  width: 100vw;
  height: 100vh;

  .header {
    width: 100%;
    background: var(--black);
    z-index: 10;

    .ht {
      padding: unit(30px) unit(30px) unit(30px);
      display: flex;
      justify-content: space-between;
      align-items: center;

      .span-logo {
        height: unit(50px);
      }

      .exit {
        height: unit(60px);
      }
    }

    .user-msg {
      padding: unit(20px) unit(30px) unit(30px);
      display: flex;
      align-items: center;

      .avatar {
        width: unit(120px);
        height: unit(120px);
        border-radius: 50%;
        margin-right: unit(30px);
      }

      .shop-msg {
        color: var(--gold);
        font-size: unit(30px);

        .shop-name {
          font-size: unit(32px);
          margin-bottom: unit(20px);
        }
      }
    }
  }

  .scan-logo {
    width: 100%;
    padding: unit(300px) 0 unit(100px);
    display: flex;
    justify-content: center;
    align-items: center;

    .nav-btn {
      width: unit(240px);
      height: unit(240px);
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      background: var(--black);

      img {
        width: unit(200px);
      }
    }
  }

  .record {
    position: fixed;
    bottom: unit(50px);
    width: 100%;
    padding: unit(10px);
    text-align: center;
    color: var(--gold);
    font-size: unit(32px);
  }
}
</style>